import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from '@/App';
import { AuthProvider } from '@/context/AuthContext';
import { CreditsProvider } from '@/context/CreditsContext';
import { AppThemeProvider } from '@/theme/ThemeProvider';
import { I18nProvider } from '@/i18n/I18nContext';
import { AwsRum, type AwsRumConfig } from 'aws-rum-web';

// Initialize AWS CloudWatch RUM
try {
	const config: AwsRumConfig = {
		sessionSampleRate: 1,
		endpoint: 'https://dataplane.rum.ap-southeast-2.amazonaws.com',
		telemetries: ['performance', 'errors', 'http'],
		allowCookies: true,
		enableXRay: false,
		signing: true // If you have a public resource policy and wish to send unsigned requests please set this to false
	};

	const APPLICATION_ID: string = 'b504ea14-75d3-4cb6-8f81-1305b2692548';
	const APPLICATION_VERSION: string = '1.0.0';
	const APPLICATION_REGION: string = 'ap-southeast-2';

	new AwsRum(APPLICATION_ID, APPLICATION_VERSION, APPLICATION_REGION, config);
} catch (error) {
	// Ignore errors thrown during CloudWatch RUM web client initialization
}

ReactDOM.createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<I18nProvider>
			<AppThemeProvider>
				<BrowserRouter>
					<AuthProvider>
						<CreditsProvider>
							<App />
						</CreditsProvider>
					</AuthProvider>
				</BrowserRouter>
			</AppThemeProvider>
		</I18nProvider>
	</React.StrictMode>
);
